<template>
  <a-modal
    :visible="visible"
    :destroy-on-close="true"
    title="Edit Tag"
    ok-text="Save"
    @ok="() => handleUpdateQuizTag()"
    @cancel="() => $emit('close')"
  >
    <a-form layout="horizontal">
      <SkInput
        v-model="updatedQuizTag.name"
        v-validate="'required|max:255'"
        :error="$validator.errors.first('name')"
        data-vv-name="name"
        label="Name"
        placeholder="Tag name"
      />
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, toRef, getCurrentInstance } from "vue";
import { QuizTagInterface, QuizTagPayloadInterface } from "../types";
import useMixin from "@/useMixin";

// Props
const props = defineProps({
  visible: { type: Boolean, default: false },
  quizTag: { type: Object as () => QuizTagInterface, default: undefined },
});

// Emits
const emits = defineEmits(["update-quiz-tag", "close"]);

// Mixins
const { setObject } = useMixin();

// Instances
const instance = getCurrentInstance();
const $validator = instance?.proxy.$validator;

// Data properties
const updatedQuizTag = ref<QuizTagPayloadInterface>({
  id: undefined,
  name: undefined,
});

// Watchers
watch(toRef(props, "visible"), (newProp, oldProp) => {
  if (newProp && !oldProp) {
    updatedQuizTag.value = setObject(updatedQuizTag.value, props.quizTag);
  }
});

// Component methods
const handleUpdateQuizTag = (): void => {
  $validator?.validateAll().then((result) => {
    if (result) {
      emits("update-quiz-tag", updatedQuizTag.value);
      emits("close");
    }
  });
};
</script>
